<template>
  <div>
    <b-row align-h="between" align-v="center">
      <b-col cols="12" md="auto" >
        <h3 class="tabheading">{{$t('audits.joomlaconfig.title')}}</h3>
        <h4 class="tabheading__subline text--right">{{$t('audits.title')}} {{ date }}</h4>
      </b-col>
      <b-col cols="12" md="auto" >
      </b-col>
    </b-row>
    <hr/>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <h2><span class="badge badge--warning">{{$t('audits.joomlaconfig.opportunities')}}</span><span class="text-small text-muted"> - {{$t('audits.joomlaconfig.opportunities_desc')}}</span></h2>
      </b-row>
      <hr/>
      <b-row>
        <b-col>
          <table class="table table--overview table--collapsable" v-if="failedAudits.length">
            <tbody>
              <tr
                      v-for="(audit, key) in failedAudits"
                      v-bind:key="key"
              >
                <td>
                  <span v-b-toggle="`collapse-item-failedaudit--${key}`" class="td-collapsable__title td-collapsable__title--warning">{{ $t(`audits.joomlaconfig.${audit}.title`) }}</span>
                  <b-collapse :id="`collapse-item-failedaudit--${key}`" class="td-collapsable__content">
                    <p>{{ $t(`audits.joomlaconfig.${audit}.description`) }}</p>
                  </b-collapse>
                </td>
                <td class="text-right align-text-top">
                  <button v-b-toggle="`collapse-item-failedaudit--${key}`"  class="collapsable__toggle">
                    <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.316406 1.28247L6.80599 8.61672C6.83336 8.64766 6.86699 8.67243 6.90465 8.6894C6.94231 8.70636 6.98314 8.71514 7.02445 8.71514C7.06575 8.71514 7.10659 8.70636 7.14425 8.6894C7.18191 8.67243 7.21554 8.64766 7.24291 8.61672L13.7331 1.28247" stroke="#999999" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="visuallyhidden">{{ $t(`audits.joomlaconfig.more_information`) }}</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="well" v-else>
            <div class="contentcontainer contentcontainer--success">
              <b-container>
                <b-row align-v="center">
                  <b-col sm="3" lg="2" xl="1">
                    <img src="/images/icon/sitedetail/dashboard/general-success.svg"/>
                  </b-col>
                  <b-col sm="9" lg="10" xl="11">
                    <p v-html="$t('audits.joomlaconfig.allpassed')"></p>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contentcontainer">
      <b-row align-v="center" class="contentcontainer__head">
        <b-col>
          <h2><span class="badge badge--success">{{ $t(`audits.joomlaconfig.passed_audits`) }}</span><span class="text-small text-muted"> - {{ passedAudits.length}} {{ $t(`audits.joomlaconfig.audits_passed`) }}</span></h2>
        </b-col>
        <b-col>
          <div class="actions">
            <button v-b-toggle.passed-audits class="collapsable__toggle">
              <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.316406 1.28247L6.80599 8.61672C6.83336 8.64766 6.86699 8.67243 6.90465 8.6894C6.94231 8.70636 6.98314 8.71514 7.02445 8.71514C7.06575 8.71514 7.10659 8.70636 7.14425 8.6894C7.18191 8.67243 7.21554 8.64766 7.24291 8.61672L13.7331 1.28247" stroke="#999999" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="visuallyhidden">{{ $t(`audits.joomlaconfig.more_information`) }}</span>
            </button>
          </div>
        </b-col>
      </b-row>
      <hr/>
      <b-collapse id="passed-audits">
        <b-row>
          <b-col>
            <table class="table table--overview table--collapsable">
              <thead>
              <tr>
                <th>
                  {{ $t(`audits.joomlaconfig.passed_audits`) }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="(audit, key) in passedAudits"
                  v-bind:key="key"
              >
                <td>
                  <span v-b-toggle="`collapse-item-passedaudit--${key}`" class="td-collapsable__title td-collapsable__title--success">{{ $t(`audits.joomlaconfig.${audit}.title`) }}</span>
                  <b-collapse :id="`collapse-item-passedaudit--${key}`" class="td-collapsable__content">
                    <p>{{ $t(`audits.joomlaconfig.${audit}.description`) }}</p>
                  </b-collapse>
                </td>
                <td class="text-right align-text-top">
                  <button v-b-toggle="`collapse-item-passedaudit--${key}`" class="collapsable__toggle">
                    <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.316406 1.28247L6.80599 8.61672C6.83336 8.64766 6.86699 8.67243 6.90465 8.6894C6.94231 8.70636 6.98314 8.71514 7.02445 8.71514C7.06575 8.71514 7.10659 8.70636 7.14425 8.6894C7.18191 8.67243 7.21554 8.64766 7.24291 8.61672L13.7331 1.28247" stroke="#919191" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="visuallyhidden">{{ $t(`audits.joomlaconfig.more_information`) }}</span>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-collapse>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'AuditJoomlaConfig',

  props: [
    'date',
    'audits'
  ],

  computed: {
    passedAudits () {
      if (!this.audits) {
        return []
      }

      let audits = []

      for (const audit in this.audits) {
        if (!this.audits.hasOwnProperty(audit)) {
          continue
        }

        if (parseInt(this.audits[audit]) === 0 || this.audits[audit] === null) {
          audits.push(audit)
        }
      }

      return audits
    },

    failedAudits () {
      if (!this.audits) {
        return []
      }

      let audits = []

      for (const audit in this.audits) {
        if (!this.audits.hasOwnProperty(audit)) {
          continue
        }

        if (parseInt(this.audits[audit]) !== 0 && this.audits[audit] !== null) {
          audits.push(audit)
        }
      }

      return audits
    }
  }
}
</script>
